import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EventHandler } from '../../../../../common/services/eventHandler';
import { AppSession } from '../../../../../common/values/appSession';
import { ResultsUtil } from '../../../../../fad/utilities/resultsUtil';
import { BaseComponent } from '../../core/baseCmp';
@Component({
  selector: 'app-fcr-pagination',
  templateUrl: './paginationCmp.html'
})
export class PaginationComponent extends BaseComponent {
  @Input()
  mapVisible: boolean;

  @Input()
  set totalPages(value: number) {
    if (value) {
      this._totalPages = value;
    }
  }
  @Input()
  set selectedPageNumber(value: number) {
    if (value) {
      this._curPageNumber = value;
    }
  }
  @Input()
  set totalRecords(value: number) {
    if (value) {
      this._totalRecords = value;
    }
  }
  @Input() resultCountText: string;
  @Output()
  pageChanged = new EventEmitter<number>();

  _curPageNumber = 1;
  _totalPages = 0;
  _totalRecords = 0;

  get numbersToDisplay(): number[] {
    const min = 1;
    let length = this._noOfPageNoToDisplay;
    let start = this._curPageNumber - Math.floor(length / 2);
    start = Math.max(start, min);
    const minVal = min + (this._totalPages - length);
    start = Math.min(start, minVal < 1 ? min : minVal);
    if (start + this._noOfPageNoToDisplay > this._totalPages) {
      length = this._totalPages - start + 1;
    }
    return Array.from({ length }, (el, i) => start + i);
  }

  private _noOfPageNoToDisplay = 3;

  constructor(
    @Inject(AppSession)
    private _appSession: AppSession,
    private _eventHandler: EventHandler,
    private _route: ActivatedRoute
  ) {
    super(_route, _eventHandler, _appSession);
  }
  ngOnInit() {
    if (this.waitUntilAppReload) {
      return;
    }
  }
  onNextClick() {
    this._curPageNumber = this._curPageNumber + 1;
    this.emitPageChangedEvent();
  }

  onPreviousClick() {
    this._curPageNumber = this._curPageNumber - 1;
    this.emitPageChangedEvent();
  }

  onFirstClick() {
    this._curPageNumber = 1;
    this.emitPageChangedEvent();
  }

  onLastClick() {
    this._curPageNumber = this._totalPages;
    this.emitPageChangedEvent();
  }

  onPageNoClick(pageNo: number) {
    this._curPageNumber = pageNo;
    this.emitPageChangedEvent();
  }

  getTotalCoundText(): string {
    const providerCountFirst = (this._curPageNumber - 1) * 20 + 1;
    let providerCountLast = (this._curPageNumber - 1) * 20 + 20;
    if (providerCountLast > this._totalRecords) {
      providerCountLast = this._totalRecords;
    }
    return this.resultCountText
      ?.replace('{providerCountFirst}', providerCountFirst.toString())
      .replace('{providerCountLast}', providerCountLast.toString())
      .replace('{totalRecords}', this._totalRecords.toString())
      .replace('{searchMiles}', this._appSession?.searchParams?.distanceNm?.toString())
      .replace('{searchLocation}', ResultsUtil.getLocationText(this._appSession));
  }

  private emitPageChangedEvent() {
    this.pageChanged.emit(this._curPageNumber);
  }

  getAnalyticsLabel(pageNumber: number): string | undefined {
    if (pageNumber >= 1) {
      const labels = {
        1: 'firstPageResultsFindCare',
        2: 'secondPageResultsFindCare',
        3: 'thirdPageResultsFindCare',
        4: 'fourthPageResultsFindCare',
        5: 'fivePageResultsFindCare'
      };
      return labels[pageNumber] || 'buttonPageResultsFindCare';
    }
  }

}
